import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';

import EditableTextMobile from './EditableTextMobile';
import EditableTextWeb from './EditableTextWeb';
import { EditableTextProps } from './types';

const EditableText: React.FC<EditableTextProps> = (props) => {
  const { isMobile } = useScreen();

  return isMobile ? <EditableTextMobile {...props} /> : <EditableTextWeb {...props} />;
};

export default React.memo(EditableText);
